import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { Typography } from '../../Typography';
import { color, getComponentOverride, spacing } from '../../../system';
import { componentSpacing06 } from '../../../tokens';
export var SideSheetFooterRoot = styled(Typography)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: center;\n    justify-content: flex-end;\n    box-sizing: border-box;\n    display: flex;\n    height: 64px;\n    margin: 0;\n    border-top: 1px solid ", ";\n    padding-top: ", ";\n    ", ";\n"])), color('neutral.03'), spacing(componentSpacing06), getComponentOverride('SideSheetFooter'));